import { useId } from "react";

interface GradientBorderProps {
  className?: string;
  borderWidth?: number; // px
  borderRadius?: number; // px
  from?: string;
  to?: string;
  direction?: "horizontal" | "vertical";
}

export function GradientBorder({
  className,
  borderWidth = 2,
  borderRadius = 30,
  from = "#7656D9",
  to = "#DE3F71",
  direction = "horizontal",
}: GradientBorderProps) {
  const id = useId();
  const gradId = `gradient_border_${id}`;
  const half = borderWidth / 2;

  const isVertical = direction === "vertical";

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      preserveAspectRatio="none"
    >
      <defs>
        {/* objectBoundingBox：渐变跟随元素缩放，最像“边框渐变” */}
        <linearGradient
          id={gradId}
          x1={isVertical ? "0%" : "0%"}
          y1={isVertical ? "0%" : "50%"}
          x2={isVertical ? "0%" : "100%"}
          y2={isVertical ? "100%" : "50%"}
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0%" stopColor={from} />
          <stop offset="100%" stopColor={to} />
        </linearGradient>
      </defs>

      <rect
        x={half}
        y={half}
        width={`calc(100% - ${borderWidth}px)`}
        height={`calc(100% - ${borderWidth}px)`}
        rx={borderRadius}
        ry={borderRadius}
        stroke={`url(#${gradId})`}
        strokeWidth={borderWidth}
        fill="none"
      />
    </svg>
  );
}
